import type { PaginatedRequestParams, PaginatedResponse } from '@/types/api';
import type { CycleInstance } from '@/types/cycle-evaluation/CycleInstance';
import type { ReviewAudience, ReviewEvaluatorSelection } from '@/types/review/ReviewAudience';
import type { ReviewInstance } from '@/types/review/ReviewInstance';

import { api } from '@/api/api';

export default {
    async getReadyToBeLaunchedReviews({
        pageNumber,
        pageSize,
        departmentIds,
        jobTitleIds,
        managerIds,
        companyAddressIds,
        employeeLevelIds,
        customAttributeIds,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<
        PaginatedResponse<CycleInstance>
    > {
        const response = await api.get('/managerdashboard/tobelaunched', {
            params: {
                pageNumber,
                pageSize,
                departmentIds,
                jobTitleIds,
                managerIds,
                companyAddressIds,
                employeeLevelIds,
                customAttributeIds,
            },
            signal,
        });

        return response.data;
    },
    async getOngoingReviews({
        pageNumber,
        pageSize,
        departmentIds,
        jobTitleIds,
        managerIds,
        companyAddressIds,
        employeeLevelIds,
        customAttributeIds,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<
        PaginatedResponse<ReviewInstance>
    > {
        const response = await api.get('/managerdashboard/ongoing', {
            params: {
                pageNumber,
                pageSize,
                departmentIds,
                jobTitleIds,
                managerIds,
                companyAddressIds,
                employeeLevelIds,
                customAttributeIds,
            },
            signal,
        });

        return response.data;
    },
    async getPastReviews({
        pageNumber,
        pageSize,
        departmentIds,
        jobTitleIds,
        managerIds,
        companyAddressIds,
        employeeLevelIds,
        customAttributeIds,
        signal,
    }: PaginatedRequestParams & { signal?: AbortSignal }): Promise<
        PaginatedResponse<ReviewInstance>
    > {
        const response = await api.get('/managerdashboard/past', {
            params: {
                pageNumber,
                pageSize,
                departmentIds,
                jobTitleIds,
                managerIds,
                companyAddressIds,
                employeeLevelIds,
                customAttributeIds,
            },
            signal,
        });

        return response.data;
    },

    async getReviewAudience(reviewAudienceId: string): Promise<ReviewAudience> {
        const response = await api.get(`/reviewaudience/${reviewAudienceId}`);

        return response.data;
    },
    async updateReviewAudience(reviewAudience: ReviewAudience) {
        const response = await api.put(`/reviewaudience/${reviewAudience.id}`, {
            reviewAudienceAssignments: reviewAudience.reviewAudienceAssignments,
        });

        return response.data;
    },
    async updateReviewEvaluatorSelection(reviewEvaluatorSelection: ReviewEvaluatorSelection) {
        const response = await api.put(
            `/reviewevaluatorselection/${reviewEvaluatorSelection.id}`,
            reviewEvaluatorSelection,
        );
        return response.data;
    },
    async getReviewEvaluatorSelection(
        reviewEvaluatorSelectionId: string,
    ): Promise<ReviewEvaluatorSelection> {
        const response = await api.get(`/reviewevaluatorselection/${reviewEvaluatorSelectionId}`);

        return response.data;
    },
};
